import React from 'react';

/** @internal */
export var infoIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1466 8.03809C9.80663 8.03809 9.53125 8.31347 9.53125 8.65347V14.7689C9.53125 15.1085 9.80663 15.3842 10.1466 15.3842C10.4866 15.3842 10.762 15.1085 10.762 14.7689V8.65347C10.762 8.31347 10.4866 8.03809 10.1466 8.03809Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1469 8H8.91617C8.57617 8 8.30078 8.27538 8.30078 8.61538C8.30078 8.95508 8.57617 9.23077 8.91617 9.23077H10.1469C10.4869 9.23077 10.7623 8.95508 10.7623 8.61538C10.7623 8.27538 10.4869 8 10.1469 8Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3777 14.1543H8.91617C8.57617 14.1543 8.30078 14.4297 8.30078 14.7697C8.30078 15.1094 8.57617 15.3851 8.91617 15.3851H11.3777C11.7177 15.3851 11.9931 15.1094 11.9931 14.7697C11.9931 14.4297 11.7177 14.1543 11.3777 14.1543Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1468 4.30762C9.46709 4.30762 8.91602 4.85869 8.91602 5.53839C8.91602 6.21808 9.46709 6.76916 10.1468 6.76916C10.8265 6.76916 11.3776 6.21808 11.3776 5.53839C11.3776 4.85869 10.8265 4.30762 10.1468 4.30762Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1469 1.23077C14.8974 1.23077 18.7623 5.09569 18.7623 9.84615C18.7623 14.5966 14.8974 18.4806 10.1469 18.4806C5.39647 18.4806 1.53155 14.5966 1.53155 9.84615C1.53155 5.09569 5.39647 1.23077 10.1469 1.23077ZM10.1469 0C4.70909 0 0.300781 4.40831 0.300781 9.84615C0.300781 15.2843 4.70909 19.6923 10.1469 19.6923C15.5851 19.6923 19.9931 15.2843 19.9931 9.84615C19.9931 4.40831 15.5851 0 10.1469 0Z"
}));